import { QueryClient } from "@tanstack/react-query";

// Single app-wide cache for server data. Pages read from it with useQuery, so
// navigating back to a page shows the last data instantly and only refetches
// in the background once it goes stale. Mutations call
// queryClient.invalidateQueries(...) to refresh whatever they changed.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Within this window a revisit uses cached data with no refetch at all.
      staleTime: 30_000,
      // Keep unused data around this long before it's dropped from memory.
      gcTime: 5 * 60_000,
      // We refresh via explicit invalidation (and per-query polling) rather
      // than on every window focus, so the table doesn't flash on alt-tab.
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

export default queryClient;
